var _path, _rect, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 210,
    viewBox: "0 0 230 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.75 166.348C74.75 146.15 91.1243 129.775 111.323 129.775H123.277C143.476 129.775 159.85 146.15 159.85 166.348H74.75Z",
    fill: "#FFD43E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 94.3,
    y: 79.0449,
    width: 46,
    height: 64.8876,
    fill: "#FFD43E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1 181.629C62.1 170.583 71.0543 161.629 82.1 161.629H152.5C163.546 161.629 172.5 170.583 172.5 181.629V210H62.1V181.629Z",
    fill: "#FFD43E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3 0H185.15V55.2809C185.15 80.1337 165.003 100.281 140.15 100.281H93.3C68.4472 100.281 48.3 80.1337 48.3 55.2809V0Z",
    fill: "#FFD43E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M189.75 1.17979C211.979 1.17979 230 17.0259 230 36.5731C230 56.1202 211.979 71.9663 189.75 71.9663C167.521 71.9663 149.5 56.1202 149.5 36.5731C149.5 17.0259 167.521 1.17979 189.75 1.17979ZM189.75 63.6909C206.782 63.6909 220.589 51.5498 220.589 36.5731C220.589 21.5963 206.782 9.45523 189.75 9.45523C172.718 9.45523 158.911 21.5963 158.911 36.5731C158.911 51.5498 172.718 63.6909 189.75 63.6909Z",
    fill: "#FFD43E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M40.25 1.17979C62.4795 1.17979 80.5 17.0259 80.5 36.5731C80.5 56.1202 62.4795 71.9663 40.25 71.9663C18.0205 71.9663 0 56.1202 0 36.5731C0 17.0259 18.0205 1.17979 40.25 1.17979ZM40.25 63.6909C57.2819 63.6909 71.089 51.5498 71.089 36.5731C71.089 21.5963 57.2819 9.45523 40.25 9.45523C23.2181 9.45523 9.41101 21.5963 9.41101 36.5731C9.41101 51.5498 23.2181 63.6909 40.25 63.6909Z",
    fill: "#FFD43E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135 17H166V46C166 63.1208 152.121 77 135 77V17Z",
    fill: "#FFEC44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.e3631a112d7520e7160d974cd3b4e84f.svg";
export { ForwardRef as ReactComponent };